
        import { applyTranslations, currentLang } from './js/lang.js';
        applyTranslations(); 

        // 1. NEJDŘÍVE DEFINUJEME BEZPEČNOSTNÍ FUNKCI
        const escapeHTML = (str) => {
            if (!str) return '-';
            return str.toString().replace(/[&<>'"]/g, 
                tag => ({
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    "'": '&#39;',
                    '"': '&quot;'
                }[tag] || tag)
            );
        };

        // 2. AŽ POTÉ ZPRACOVÁVÁME DATA A POUŽÍVÁME JI
        const urlParams = new URLSearchParams(window.location.search);
        const slotId = urlParams.get('id');
        const coord = urlParams.get('coord');
        
        // Nyní už escapeHTML existuje a nevyhodí chybu
        document.getElementById('slot-coord').innerText = coord ? `(${escapeHTML(coord)})` : ''; 

        // Pomocná funkce pro barevné odlišení stavů
        const getStatusBadge = (status, isPrevious = false) => {
            let color = '#8b949e'; // Výchozí šedá
            let bg = 'transparent';
            let border = '#333a45';
            
            if (status === 'OCCUPIED') { color = '#4ade80'; border = '#166534'; bg = isPrevious ? 'transparent' : 'rgba(74, 222, 128, 0.1)'; }
            if (status === 'INBOUND') { color = '#60a5fa'; border = '#1e3a8a'; bg = isPrevious ? 'transparent' : 'rgba(96, 165, 250, 0.1)'; }
            if (status === 'RESERVED') { color = '#f59e0b'; border = '#78350f'; bg = isPrevious ? 'transparent' : 'rgba(245, 158, 11, 0.1)'; }
            if (status === 'BLOCKED') { color = '#ef4444'; border = '#7f1d1d'; bg = isPrevious ? 'transparent' : 'rgba(239, 68, 68, 0.1)'; }
            if (status === 'EMPTY') { color = '#e5e7eb'; border = '#4b5563'; bg = isPrevious ? 'transparent' : 'rgba(255, 255, 255, 0.05)'; }
            
            return `<span style="display:inline-block; min-width: 75px; text-align: center; color: ${color}; background: ${bg}; border: 1px solid ${border}; border-radius: 4px; padding: 2px 6px; font-size: 0.7rem; font-weight: bold; letter-spacing: 0.5px;">${escapeHTML(status)}</span>`;
        };

        async function loadHistory() {
            if (!slotId) {
                document.getElementById('history-table').innerHTML = `<tr><td colspan="6" class="text-danger text-center py-4">No Slot ID provided in URL.</td></tr>`;
                return;
            }

            try {
                const res = await fetch(`/api/slot-logs?id=${slotId}`);
                if (!res.ok) throw new Error("Failed to fetch logs");
                const data = await res.json();

                // Aktualizace KPI
                document.getElementById('kpi-total').innerText = data.logs.length;
                document.getElementById('kpi-emptied').innerText = data.logs.filter(l => l.new_status === 'EMPTY').length;
                document.getElementById('kpi-dwell').innerText = data.slot.status === 'OCCUPIED' ? data.currentDwell : '-';
                document.getElementById('kpi-freq').innerText = escapeHTML(data.frequentPart); // Zabezpečeno

                // Aktualizace tabulky
                let html = '';
                if (data.logs.length === 0) {
                    html = `<tr><td colspan="6" class="text-muted text-center py-4">No history recorded for this slot.</td></tr>`;
                } else {
                    data.logs.forEach(log => {
                        const dateTime = new Date(log.timestamp).toLocaleString([], {
                            year: 'numeric', month: 'numeric', day: 'numeric', 
                            hour: '2-digit', minute:'2-digit'
                        });
                        
                        let eventBadge = 'bg-dark';
                        if (log.event_type.includes('PUTAWAY')) eventBadge = 'bg-success text-dark';
                        else if (log.event_type.includes('PICK')) eventBadge = 'bg-primary text-white';
                        else if (log.event_type.includes('MAINTENANCE') || log.event_type.includes('ERROR')) eventBadge = 'bg-danger text-white';

                        html += `
                            <tr>
                                <td style="color: #6e7681;">${dateTime}</td>
                                <td><span class="badge ${eventBadge} border border-secondary" style="font-size: 0.65rem;">${escapeHTML(log.event_type)}</span></td>
                                <td>
                                    ${getStatusBadge(log.previous_status, true)} 
                                    <span style="color: #4b5563; margin: 0 8px;">➔</span> 
                                    ${getStatusBadge(log.new_status, false)}
                                </td>
                                <td style="font-family: monospace; color: #60a5fa;">${escapeHTML(log.part_number)}</td>
                                <td class="text-white">${escapeHTML(log.quantity)}</td>
                                <td style="color: #8b949e;">${escapeHTML(log.operator_id)}</td>
                            </tr>
                        `;
                    });
                }
                document.getElementById('history-table').innerHTML = html;

            } catch (err) {
                console.error(err);
                document.getElementById('history-table').innerHTML = `<tr><td colspan="6" class="text-danger text-center py-4">Error loading history.</td></tr>`;
            }
        }

        loadHistory();
    